import Vue from "vue";
import Vuex from "vuex";
// Entities
import { Profile } from "@/entities/models/Profile";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    profile: new Profile(),
    warehouse: "",
  },
  getters: {
    profile: (state) => state.profile,
    company: (state) => state.profile.company,
    transportByTempo: (state) => state.profile.company.transportByTempo,
    warehouse: (state) => state.warehouse,
    role: (state) => state.profile.role,
    lang: (state) => state.profile.lang,
    isAdmin: (state) => state.profile.role === "admin",
  },
  mutations: {
    profile(state, value) {
      state.profile = value;
    },
    warehouse(state, value) {
      state.warehouse = value;
    },
  },
  actions: {},
  modules: {},
});
